import { render } from "./genrePage.vue?vue&type=template&id=23b0d9ea&scoped=true"
import script from "./genrePage.vue?vue&type=script&lang=js"
export * from "./genrePage.vue?vue&type=script&lang=js"

import "./genrePage.vue?vue&type=style&index=0&id=23b0d9ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b0d9ea"]])

export default __exports__